import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class AppService {

    constructor() { }

    sendGaData(eventActionName: string, eventLabel?: string, eventCategory?: string) {
        const dataLayer = window['dataLayer'];
        dataLayer.push({
            event: 'ga_event',
            eventCategory: eventCategory ? eventCategory : 'Campaign LP',
            eventAction: eventActionName,
            eventLabel: eventLabel ? eventLabel : ' LP202310_Bezpieczenstwo_rowerowe_dzieci'
        });
    }


}
